// components/Breadcrumbs.tsx
import Link from "next/link";

// type for breadcrumb items
interface BreadcrumbItem {
  label: string;
  url?: string | null; // Allow null values
}

// props interface for the component
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs = ({ items = [] }: BreadcrumbsProps) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className="mt-4 mb-2 px-0 py-0">
      <ol className="flex flex-wrap items-center text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center">
              {item.url && !isLast ? (
                <Link
                  href={item.url}
                  className="text-[#222222] hover:text-[#222222] underline underline-offset-2 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-[#222222]" : "text-[#222222]"}>
                  {item.label}
                </span>
              )}
              {!isLast && <span className="mx-2 text-[#222222]">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
